export const translationOptions = [{
    label: '中',
    value: 'tc'
}, {
    label: 'EN',
    value: 'en'
}];